import React, { useContext, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Images } from "../../assets/common";
import { useHistory } from "react-router-dom";
import { kFormatter, fullName } from "../../constants/function";
import NoData from "../Nodata";
import { SocketContext } from "../../context/socket";
import { useTranslation } from "react-i18next";
export default function OnlineUsers({ users, onClose, playListId }) {
  const { t } = useTranslation("common");
  const socket = useContext(SocketContext).Socket;
  const [onlineUsers, setOnlineUsers] = useState([]);

  React.useEffect(() => {
    socket.on("onlineuser", (u) => {
      setOnlineUsers([...u]);
    });
  }, [socket]);

  React.useEffect(() => {
    setOnlineUsers([...users]);
  }, [users]);
  const history = useHistory();
  return (
    <Box className="_chat_onlineUsers">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="_chat_onlineUsers_headers"
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography className="fs-17">Users Online</Typography>
          <Typography className="fs-12">({onlineUsers.length})</Typography>
        </Stack>
        <img
          title="Close"
          style={{ width: "12px", height: "12px" }}
          src={Images.arrow_down}
          className="_cp"
          onClick={() => onClose()}
          alt="close"
        />
      </Stack>
      <Stack
        spacing={1}
        className={
          users ? "_chat_onlineUsers_box" : "_chat_onlineUsers_box_hide"
        }
      >
        {onlineUsers.length > 0 ? (
          onlineUsers.map((user, index) => (
            <Stack key={index} alignItems="center" direction="row" spacing={1}>
              <img
                className="avatar"
                src={
                  user["user"] && user["user"]["profileImg"]
                    ? user["user"]["profileImg"]["filePath"]
                    : Images.dummy1
                }
                alt="user"
              />
              <Stack direction="column">
                <Typography
                  className="fs-15 _cp"
                  onClick={() =>
                    window.open(`/app/ArtistProfile/${user["user"]["_id"]}`, "_blank")
                  }
                >
                  {fullName(user["user"])}
                </Typography>
                <Typography className="fs-13 faded">
                  {kFormatter(user["user"] ? user["user"]["followerCount"] : 0)}{" "}
                  Followers
                </Typography>
              </Stack>
            </Stack>
          ))
        ) : (
          <Box sx={{ position: "relative" }}>
            <NoData lable={t("noData.noData")} />
          </Box>
        )}
      </Stack>
    </Box>
  );
}
